export function mapRegionForLocale(region: string | undefined): string | undefined {
  if (!region) return region;
  const lower = region.toLowerCase();
  if (lower === 'uk') return 'GB';
  return region.toUpperCase();
}

export function getEffectiveLocale({
  lang,
  region,
  urlLocale,
  urlRegion,
}: {
  lang?: string;
  region?: string;
  urlLocale?: string | null;
  urlRegion?: string | null;
}): string | undefined {
  const effectiveRegion = mapRegionForLocale(urlRegion || region);
  return urlLocale || (lang && effectiveRegion ? `${lang}-${effectiveRegion}` : undefined);
}
